/** All possible barometer deficit statuses (with Polish diacritics) */
export const BAROMETER_STATUSES = [
  "duży deficyt",
  "deficyt",
  "równowaga",
  "nadwyżka",
] as const;

export type BarometerStatus = (typeof BAROMETER_STATUSES)[number];

/** Default barometer statuses (deficit-focused) */
export const DEFAULT_BAROMETER_STATUSES: readonly BarometerStatus[] = [
  "deficyt",
  "duży deficyt",
];
